<div class="camera-uploader-container">
  <ion-card
    class="camera-uploader-interactive"
    [class.error-border]="errorState"
  >
    <ion-card-content class="device-width">
      <div class="square-container">
        <app-camera-uploader-square
          *ngFor="let square of squaresArray | async; let i = index"
          data-cy="photo-card-{{ i }}"
          (squareClicked)="handleSquareClicked($event, i)"
          [index]="i"
          [photo]="square"
          [photos]="photos | async"
          [errorState]="errorState"
          [showAddText]="(photos | async).length === i"
        >
        </app-camera-uploader-square>
      </div>
    </ion-card-content>
  </ion-card>
  <div *ngIf="errorState" class="error-text">
    {{ errorState }}
  </div>
</div>
